import { MprcChipChoice } from "components";
import { TopicSearchDto } from "generated/CoreApi_v1";
import * as React from "react";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: TopicSearchDto;
    onBeforeLinkClick?: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderTopic: React.FC<IProps> = (props) => {
    const navigate = useNavigate();
    const { data, onBeforeLinkClick } = props;
    const navUrl = KnowledgePaths.FeedTopic(data.topicId);

    return (
        <MprcChipChoice
            label={data.name}
            title={data.name}
            onClick={
                navUrl ? () => {
                    onBeforeLinkClick && onBeforeLinkClick();
                    navigate(navUrl);
                } : undefined
            }
        />
    );
};
